import React from "react";
import { Entity } from "@common/types/entity";
import { ConsolidationRelationshipResponse } from "@common/schemas/domains/accounting/consolidation.schema";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { getEdgeLabel } from "../ownershipGraph.helpers";
import { PaneSection } from "./PaneSection";
import { RelationshipProperties } from "./RelationshipProperties";
import styles from "./Pane.module.scss";

interface RelationshipBundlePaneProps {
    relationships: ConsolidationRelationshipResponse[];
    entitiesByUuid: Map<string, Entity>;
    onSelectRelationship: (relationshipId: string) => void;
    onEditRelationship: (
        relationship: ConsolidationRelationshipResponse,
    ) => void;
    onDeleteRelationship: (relationshipId: string) => void;
}

/**
 * Side-panel view of a bundle: one accordion section per relationship (label as
 * the title), each showing the same properties as the single relationship pane
 * plus edit and delete actions for that relationship.
 */
export const RelationshipBundlePane: React.FC<RelationshipBundlePaneProps> = ({
    relationships,
    entitiesByUuid,
    onSelectRelationship,
    onEditRelationship,
    onDeleteRelationship,
}) => (
    <div className={styles.pane}>
        {relationships.map((relationship) => (
            <PaneSection
                key={relationship.id}
                title={getEdgeLabel(relationship)}
                defaultExpanded
                onHeaderClick={() => onSelectRelationship(relationship.id)}
            >
                <RelationshipProperties
                    relationship={relationship}
                    entitiesByUuid={entitiesByUuid}
                />
                <HStack justify="end" gap={8} paddingBlock={8}>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => onEditRelationship(relationship)}
                    >
                        Edit
                    </Button>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => onDeleteRelationship(relationship.id)}
                    >
                        Delete
                    </Button>
                </HStack>
            </PaneSection>
        ))}
    </div>
);
